// Helpers shared by the accounts sidebar tile and the Contact Information page

// Short labels for anything missing or unverified, in page order
export function contactIssues(contact) {
    if (!contact) return [];
    const issues = [];
    if (!contact.email) issues.push('No email');
    else if (!contact.verified.email) issues.push('Email not verified');
    if (!contact.phone) issues.push('No text number');
    else if (!contact.verified.phone) issues.push('Phone not verified');
    const a = contact.address || {};
    if (!(a.address && a.city && a.state && a.zip)) issues.push('No mailing address');
    else if (!contact.verified.address) issues.push('Address not verified');
    return issues;
}

// PostGrid's street search treats punctuation as part of the word: county
// roads written "S Cheney-Plaza Rd" match nothing, while "S Cheney Plaza Rd"
// is found (2026-10-02, plan R32273). Hyphens inside a street name and periods
// after letters (N.W.) become spaces; a house number like "123-B" is left
// alone. Use the same cleaned text for the suggestion list and the pick, which
// re-sends it.
export function postgridStreetQuery(value) {
    return String(value || '')
        .replace(/([A-Za-z])-+(?=[A-Za-z])/g, '$1 ')
        .replace(/([A-Za-z])\./g, '$1 ')
        .replace(/\s+/g, ' ')
        .trim();
}

// TPO has no number it can text: login codes and payment-method approval by
// text are unavailable until one is verified
export function needsTextNumber(contact) {
    return !!contact && !contact.sms;
}

export function formatPhone(value) {
    const d = String(value || '').replace(/\D/g, '');
    return d.length === 10 ? `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}` : value;
}
